import React, { useEffect } from "react";
// import PageTitle from "../../components/shared/PageTitle";
// import PageHeadline from "../../components/shared/PageHeadline";
import { useTranslation } from "react-i18next";
import { ChatBubbleBottomCenterTextIcon } from "@heroicons/react/24/outline";
// import axios from "axios";

export default function Index() {
    const { t } = useTranslation();

    useEffect(() => {
        // Set the configuration object for FreeScout widget
        window.FreeScoutW = {
            s: {
                color: "#00900e",
                position: "br",
                id: 3466666910
            }
        };

        // Inject the script if not already present
        if (document.getElementById("freescout-w")) return;

        const script = document.createElement("script");
        script.id = "freescout-w";
        script.async = true;
        script.src = "https://ticket.intelligence.co.id/modules/enduserportal/js/widget.js?v=7479";
        document.body.appendChild(script);
    }, []);


    return (
        <div className="text-brandDarkGreen md:px-0 px-4 bg-main bg-cover bg-bottom md:bg-right bg-no-repeat">
            {/* <div className="relative">
                <PageTitle title={t("contact.title")} />
            </div> */}
            {/* <div className="relative min-h-[240px] lg:min-h-[300px] bg-bgBannerPage bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={t("contact.title")} />
            </div> */}
            <div className="top-24 md:top-40 relative md:px-16 lg:px-24 xl:px-28 2xl:px-36 px-0 py-5 pb-96">
                <div className="basis-full py-8 max-md:max-w-[200px] max-md:text-wrap">
                    <span className="jersey25 font-bold uppercase text-5xl md:text-8xl text-white">{t("contact.title")}</span>
                </div>
                <div className="bg-white min-h-fit container px-8 py-6 rounded-3xl w-fit font-poppins text-brandDarkGreen">
                    <div className="flex items-center justify-start h-fit w-full">
                        <div className="flex flex-col items-center text-center space-y-4">
                            <div className="w-16 h-16 bg-brandDarkGreen/10 rounded-full flex items-center justify-center mb-2">
                                <ChatBubbleBottomCenterTextIcon className="w-8 h-8 text-brandDarkGreen" />
                            </div>
                            <h2 className="text-xl font-bold text-gray-800">
                                Hubungi Kami
                            </h2>
                            <p className="text-gray-600 max-w-sm">
                                Klik ikon chat di pojok kanan bawah untuk berbicara dengan tim support kami.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
